<template>
  <TemplateSolicitacao
    v-if="idTemplate"
    :id-template="idTemplate"
    :titulo="tituloNavegacao"
    :id-funcionalidade="funcionalidade.idFuncionalidade"
    :id-tipo-ocorrencia="idTipoOcorrencia"
    listagem-popup
  />
</template>

<script>
import TemplateSolicitacao from '@/components/TemplateSolicitacao/TemplateSolicitacao'
import { mapState } from 'vuex'

export default {
  name: 'Func16Novo',
  components: { TemplateSolicitacao },
  computed: {
    ...mapState('SetupApp', ['funcionalidade']),
    tituloNavegacao () {
      return this.funcionalidade.parametros.dashboard.nome
    },
    idTemplate () {
      return this.funcionalidade.parametros.idTemplateSolicitacao
    },
    idTipoOcorrencia () {
      return this.funcionalidade.parametros.idTipoOcorrencia
    }
  }
}
</script>

<style scoped>

</style>
